import cookie from 'react-cookies';

/**
 * Процент пользователей с JWT-авторизацией (0–100).
 * Cookie jwt_auth_bucket общий с monocle (.welltory.com).
 *
 * При раскатке менять то же число в:
 * - server/auth/jwtRollout.js
 * - monocle src/utils/auth/jwtRollout.ts
 */
export const JWT_AUTH_ROLLOUT_PERCENT = 100;
export const JWT_AUTH_BUCKET_COOKIE = 'jwt_auth_bucket';
export const JWT_AUTH_BUCKET_COOKIE_MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000;
export const JWT_AUTH_BUCKET_COOKIE_DOMAIN = '.welltory.com';

const JWT_AUTH_BUCKET_MAX = 100;

export function parseJwtAuthBucket(raw) {
  if (raw == null || raw === '') {
    return null;
  }

  const bucket = Number(raw);

  if (
    !Number.isInteger(bucket) ||
    bucket < 0 ||
    bucket >= JWT_AUTH_BUCKET_MAX
  ) {
    return null;
  }

  return bucket;
}

export function createJwtAuthBucket() {
  return Math.floor(Math.random() * JWT_AUTH_BUCKET_MAX);
}

function clampRolloutPercent(percent) {
  if (typeof percent !== 'number' || Number.isNaN(percent)) {
    return 0;
  }

  return Math.min(JWT_AUTH_BUCKET_MAX, Math.max(0, percent));
}

export function isJwtAuthEnabledForBucket(bucket) {
  if (bucket == null) {
    return false;
  }

  return bucket < clampRolloutPercent(JWT_AUTH_ROLLOUT_PERCENT);
}

export function isJwtAuthEnabledFromCookies(cookies) {
  const raw = cookies && cookies[JWT_AUTH_BUCKET_COOKIE];

  return isJwtAuthEnabledForBucket(parseJwtAuthBucket(raw));
}

export function isJwtAuthEnabledInBrowser() {
  if (typeof window === 'undefined') {
    return false;
  }

  return isJwtAuthEnabledFromCookies({
    [JWT_AUTH_BUCKET_COOKIE]: cookie.load(JWT_AUTH_BUCKET_COOKIE),
  });
}

export function ensureJwtAuthBucketInBrowser() {
  if (typeof window === 'undefined') {
    return;
  }

  if (parseJwtAuthBucket(cookie.load(JWT_AUTH_BUCKET_COOKIE)) != null) {
    return;
  }

  cookie.save(JWT_AUTH_BUCKET_COOKIE, String(createJwtAuthBucket()), {
    path: '/',
    domain: JWT_AUTH_BUCKET_COOKIE_DOMAIN,
    expires: new Date(Date.now() + JWT_AUTH_BUCKET_COOKIE_MAX_AGE_MS),
  });
}
